import { AbpHttpConfigurationService, AbpHttpInterceptor } from 'abp-ng2-module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CustomHeaderInterceptor } from './customHeaderInterceptor';
import * as ApiServiceProxies from './service-proxies';
import { ZeroTemplateHttpConfigurationService } from './zero-template-http-configuration.service';

@NgModule({
    providers: [
        ApiServiceProxies.AssetAuditHistoriesServiceProxy,
        ApiServiceProxies.AssetAuditSyncServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.PlaceServiceProxy,
        ApiServiceProxies.ZoneServiceProxy,
        ApiServiceProxies.PropertyServiceProxy,
        ApiServiceProxies.DepositServiceProxy,
        ApiServiceProxies.PurchaseRequestServiceProxy,
        ApiServiceProxies.PurchaseProcessServiceProxy,
        ApiServiceProxies.RequestApprovalServiceProxy,
        ApiServiceProxies.SapOrderReceptionServiceProxy,
        ApiServiceProxies.AssetCreationServiceProxy,
        ApiServiceProxies.GroupServiceProxy,
        ApiServiceProxies.SubgroupServiceProxy,
        ApiServiceProxies.AssetReceptionServiceProxy,
        ApiServiceProxies.AssetTransferenceServiceProxy,
        ApiServiceProxies.AssetServiceProxy,
        ApiServiceProxies.AssetRemovalServiceProxy,
        ApiServiceProxies.MovementsServiceProxy,
        ApiServiceProxies.UserDelegationServiceProxy,
        ApiServiceProxies.TwitterServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        { provide: AbpHttpConfigurationService, useClass: ZeroTemplateHttpConfigurationService },
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CustomHeaderInterceptor,
            multi: true
        }
    ]
})
export class ServiceProxyModule { }
